import { Input, Button, ConfigProvider, Checkbox } from "antd";
import { useEffect, useState } from "react";
import CustomInputNumberV2 from "../../CustomInputNumberV2";
import {CharLimit as charLimit} from "../../../constant/constants";

function FoodVariantAddOns({ records }) {
  const { title, placeholder, isDisabled, data, setOptions, setAddOns, context } = records;

  const [foodOptions, setFoodOptions] = useState([]);
  const [hasMultipleOptions, setHasMultipleOptions] = useState(false);

  useEffect(() => {
    if (context === "VARIANTS") {
      setFoodOptions(data.map((item) => ({ ...item })));
      setHasMultipleOptions(data.length > 1);
    }
  }, [data, context]);

  const handleAdd = (context) => {
    if (context === "VARIANTS") {
      const newData = { optionId: "", name: "", weight: 1, price: "", isSelected: false, isDisabled: false };
      setFoodOptions((prev) => [...prev, newData]);
      setOptions((prev) => [...prev, newData]);
      setHasMultipleOptions(true);
    } else {
      const newData = { name: "", price: "" };
      setAddOns((prev) => [...prev, newData]);
    }
  };

  const handleRemove = (index, context) => {
    if (context === "VARIANTS") {
      const updatedData = [...foodOptions];
      updatedData.splice(index, 1);
      setOptions(updatedData);
    } else {
      const updatedData = [...data];
      updatedData.splice(index, 1);
      setAddOns(updatedData);
    }
  };

  const handleFieldChange = (index, field, value) => {
    // Enforce max 100 characters
    if (value.length > charLimit.Name) return;

    if (context === "VARIANTS") {
      const updatedData = [...foodOptions];
      updatedData[index][field] = value;
      if (setOptions) setOptions(updatedData);
    } else {
      const updatedData = [...data];
      updatedData[index][field] = value;
      if (setAddOns) setAddOns(updatedData);
    }
  };

  const onChangeInput = ({ name, value }) => {
    const [index, field] = name.split("_");
    handleFieldChange(index, field, value);
  };

  const handleVariantSelect = (index, item, isSelected) => {
    const updatedData = [...foodOptions];
    updatedData[index].isSelected = isSelected;
    setOptions(updatedData);
  };

  return (
    <div className="mb-4">
      <div className="w-full">
        <label className="text-sm font-semibold">{title}</label>
      </div>

      {context === "VARIANTS"
        ? foodOptions.map((item, index) => (
            <div key={index} className="w-full h-[45px] flex items-center">
              {/* Main fields */}
              <div className="flex-1 flex items-center gap-x-[20px]">
                {hasMultipleOptions && (
                  <ConfigProvider
                    theme={{
                      token: {
                        colorPrimary: "#572D86",
                        colorPrimaryBorder: "#572D86",
                        colorPrimaryHover: "#572D86",
                        controlOutline: "#572D86",
                        colorBorder: "#572D86",
                      },
                    }}
                  >
                    <Checkbox
                      checked={item.isSelected}
                      onChange={(e) => handleVariantSelect(index, item, e.target.checked)}
                    />
                  </ConfigProvider>
                )}

                <div className="flex-1 h-full">
                  <Input
                    value={item.name}
                    placeholder={placeholder}
                    onChange={(e) => handleFieldChange(index, "name", e.target.value)}
                    className="h-[32px]"
                  />
                </div>

                {foodOptions.length > 1 && (
                  <div className="w-[130px] h-full">
                    <CustomInputNumberV2
                      name={`${index}_weight`}
                      placeholder=""
                      min={0}
                      max={999}
                      value={item.weight}
                      setValue={onChangeInput}
                      shouldSetValueSetObj={true}
                      isDecimalAllowed={true}
                      addonBefore="Weight"
                    />
                  </div>
                )}

                <div className="w-[150px] h-full">
                  <CustomInputNumberV2
                    name={`${index}_price`}
                    placeholder=""
                    min={0}
                    max={99999}
                    value={item.price}
                    setValue={onChangeInput}
                    shouldSetValueSetObj={true}
                    isDecimalAllowed={true}
                    addonBefore="Price"
                  />
                </div>
              </div>

              {/* Remove button */}
              <div
                className={`w-[48px] h-full flex items-center justify-center ${
                  foodOptions.length === 1 ? "invisible pointer-events-none" : ""
                }`}
              >
                <Button
                  type="link"
                  className="w-full h-full flex items-center justify-center p-0"
                  onClick={() => handleRemove(index, context)}
                >
                  <img
                    src="/images/icons/remove.svg"
                    alt="Remove"
                    className="w-[36px] h-[36px]"
                  />
                </Button>
              </div>
            </div>
          ))
        : data.map((item, index) => (
            <div key={index} className="w-full h-[45px] flex items-center ">
              <div className="flex-1 flex items-center gap-x-[20px]">

              <div className="flex-1 h-full">
                <Input
                  value={item.name}
                  placeholder={placeholder}
                  disabled={isDisabled}
                  onChange={(e) => handleFieldChange(index, "name", e.target.value)}
                  className="h-[32px]"
                />
              </div>

              <div className="w-[200px] h-full">
                <CustomInputNumberV2
                  name={`${index}_price`}
                  placeholder=""
                  min={0}
                  max={99999}
                  value={item.price}
                  setValue={onChangeInput}
                  shouldSetValueSetObj={true}
                  isDecimalAllowed={true}
                  addonBefore="Price"
                />
              </div>
              </div>

              {context === "ADD-ONS" && (
                <div className="w-[48px] h-full flex items-center justify-center">
                  <Button
                    className="w-full h-full flex items-center justify-center p-0"
                    onClick={() => handleRemove(index, context)}
                    type="link"
                  >
                    <img
                      src="/images/icons/remove.svg"
                      alt="Remove"
                      className="w-[36px] h-[36px]"
                    />
                  </Button>
                </div>
              )}
            </div>
          ))}

      <div className="flex items-center justify-start mt-1">
        <Button type="link" onClick={() => handleAdd(context)} className="flex items-center space-x-2 p-0">
          <img src="/images/icons/add-icon-new.svg" alt="Add" className="w-[30px] h-[30px]" />
        </Button>
      </div>
    </div>
  );
}

export default FoodVariantAddOns;
